var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapa1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_78_237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 2.64694C7.26545 1.14558 15.016 5.97882 18.1452 7.92836C18.5326 8.1697 22.4005 10.9032 27.2797 12.1451C30.5418 12.9758 34.2554 13.1392 37.6825 11.4466C36.6523 18.5421 30.6206 24.1954 22.1633 20.8651C17.1421 18.8877 16.0175 13.5693 12.432 10.1898C6.30011 4.41179 2.80653 3.32743 0 2.64694Z",
    fill: "#4C88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1451 7.92826C16.2514 5.08479 13.7109 2.44408 9.17313 0.00858011C18.2519 -0.231932 23.2575 4.63578 28.3591 8.09489C28.2475 9.99601 27.7952 11.1099 27.2797 12.145C22.4013 10.9031 18.5326 8.16959 18.1451 7.92826Z",
    fill: "#2461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7067 2.65593C37.0381 3.8117 37.4477 9.332 37.6825 11.4465C34.2554 13.1392 30.5418 12.9758 27.2797 12.1451C27.7952 11.11 28.2475 9.99608 28.3592 8.09496C28.6481 0.329608 36.1459 -0.422301 38.4894 3.05979C38.7522 3.52073 40.3166 3.24253 42.2691 2.89534C44.3292 2.529 46.8212 2.08584 48.6722 2.35303C48.8643 2.3752 48.8988 2.63869 48.7067 2.65593ZM36.7606 3.92663C36.7606 3.51784 36.4257 3.18293 36.0169 3.18293C35.6082 3.18293 35.2732 3.51456 35.2732 3.92663C35.2732 4.3387 35.6082 4.67033 36.0169 4.67033C36.4257 4.67033 36.7606 4.33542 36.7606 3.92663Z",
    fill: "#003F8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.6825 11.4463C36.6523 18.5418 30.6206 24.1951 22.1633 20.8649C18.9323 24.6934 17.069 28.3429 16.1168 31.6805C17.5894 27.4235 23.9215 27.0484 29.1332 25.1374C35.7502 22.711 38.6166 18.0706 37.6825 11.4463Z",
    fill: "#F5B740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.1332 25.1377C23.1787 28.5689 18.6656 31.4608 15.9206 42.077C15.8295 42.6163 15.3624 43.0152 14.8174 43.012C14.9963 40.3852 14.7714 36.3934 16.116 31.6808C17.5886 27.4238 23.9207 27.0487 29.1324 25.1377H29.1332Z",
    fill: "#003F8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8347,
    height: 43.0115,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapa1);
export default __webpack_public_path__ + "static/media/capa_1.d79f2e45225a212d1c700b731126a97f.svg";
export { ForwardRef as ReactComponent };